import { encode as base64_encode} from 'base-64';
import config from "../config";
import { message } from "antd";
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';


class AssetRegisteredReportStore {
  assetReport=[]
  total=0
  loading=false
  rootStore
  rec=0
  constructor(rootStore) {
    makeObservable(this, {
        assetReport: observable,
      total:observable,
      loading:observable,
      rec:observable,
      loadData:action,
      exportExcel:action,
      exportcsv:action,
      exportpdf:action,
      exportxml:action
     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,fromDate,toDate, pageNo}) {
    // console.log("assetReport")
    this.loading=true;
    var postData = {"companyId":companyId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":pageNo}
    if(config.pythonReport === 1){
      // postData.companyId=10166
        var response = await postApi.getClient('report').post("/admin/vehicleRegister", postData);
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicle&a=vehicleregisterreport", "postData="+base64Input);
    }
    // console.log("assetre[prt] " ,response?.data?.data)
   
    this.assetReport =response?.data?.data?.vehicleregister
    if(this.assetReport.length >0){
      this.rec=1
    }
     this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }

  async exportExcel(getDta){
    // console.log(getDta)
    if(config.pythonReport === 1){    
        try {
            var response = await postApi.getClient("report").post("/admin/vehicleRegister/download/excel", getDta, {
                responseType: "blob",
            });
        
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Vehicle Register Report.xlsx";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
      
        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }

    }else{
      window.location.href = baseURL + "index.php?c=vehicle&a=exportvehicleregisterexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + 
      '&colList=' + getDta.colList
    }
  
  }

  async exportpdf(getDta){
    if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("/admin/vehicleRegister/download/pdf", getDta, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Vehicle Register Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
      window.location.href = baseURL + "index.php?c=vehicle&a=exportvehicleregisterpdf&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
    }
   
  }

  async exportcsv(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportvehicleregistercsv&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
  }
  async exportxml(getDta){
    window.location.href = baseURL + "index.php?c=vehicle&a=exportvehicleregisterxml&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
  }
  

  
  

}

export default AssetRegisteredReportStore;
